module.exports = __webpack_public_path__ + "static/logo_covesity-186f7de6d12c5db839b508ada086feec.svg";